<div class="side-wrap" (click)="closeNewSideNav($event)" [attr.data-locale]="currentLocale">
  <div class="side-area">
    <div class="side-body">

      <div class="sideLogin">
        <div class="banner" *ngIf="localeTexts.length" [style.backgroundImage]="'url('+ localeTexts[0].headerBanner.imageURL +')'">
          <div class="bigLogoLayer">
            <img src="{{localeTexts[0].bigLoyaltyLogo.imageURL}}" alt="Big Loyalty Logo">
            <div class="userName">
              <span *ngIf="loggedIn">{{userName}}</span>
            </div>
          </div>
        </div>

        <div class="login">
          <aa-sso-widget *ngIf="!loggedIn" [isMobileView]='true'></aa-sso-widget>
          <login-widget *ngIf="loggedIn"></login-widget>
        </div>
      </div>

    </div>
  </div>

  <div class="closeMark cl">
    <div class="x cl">
      <i class="material-icons cl">clear</i>
    </div>
    <div class="menu cl">
        <i class="material-icons cl">menu</i>
    </div>
  </div>

</div>